import * as React from 'react';

type Props = {
  className?: string;
};

const PhoneFilledIcon: React.FC<Props> = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    overflow="visible"
    width="20px"
    height="26px"
    viewBox="0 0 20 26"
    version="1.1"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M19.7568486,23.5788605 L16.8809735,25.5794692 L16.8809735,25.5794692 C15.0887614,26.7048117 8.96189707,23.4121431 4.54388604,17.20192 C0.125875,10.9916969 -0.916108735,4.1146043 0.751065241,2.86422382 L0.751065241,2.86422382 L3.62694035,0.863615046 C3.87701645,0.696897649 4.25213059,0.738576998 4.41884799,0.988653094 L8.75350032,7.07383811 C8.92021772,7.3239142 8.87853837,7.657349 8.62846228,7.86574574 L5.75258717,9.86635451 C6.25273936,11.4084904 7.08632635,13.0339851 8.16998943,14.6178003 C9.25365252,16.2016156 10.5873917,17.4936755 11.8794515,18.4939798 L14.7553266,16.4933711 C15.0054027,16.3266537 15.3805169,16.368333 15.5472343,16.6184091 L19.8818866,22.7035941 C20.0902834,23.0370289 20.0069247,23.3704637 19.7568486,23.5788605 Z"
        fill="#FFFFFF"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default PhoneFilledIcon;
